import type { Dispatch, SetStateAction } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { StyleSheet } from 'react-native-unistyles';
import Box from '@/components/UI/Box';
import getEmptyEntity from '@/utils/getEmptyEntity';
import getRandomColor from '@/utils/getRandomColor';
import * as Header from '../Custom/Header';
import Icon from '../Unistyles/Icon';
import type { EntityListValues } from './EntityList.types';
import EntityListAvatar from './EntityListAvatar';
import EntityListMenu from './EntityListMenu';
import EntityListTitle from './EntityListTitle';
export default (function EntityListInput({
  name,
  index,
  isMenuOpen,
  setMenuIndex,
}: {
  name: string;
  index: number;
  isMenuOpen: boolean;
  setMenuIndex: Dispatch<SetStateAction<number | null>>;
}) {
  const { control, setValue, getValues } = useFormContext<EntityListValues>();
  const title = useWatch({
    name: `${name}.${index}.title`,
    control,
  });
  return (
    <Box
      direction="horizontal"
      alignItems="center"
      background={isMenuOpen ? 'surfaceSecondary' : undefined}
      px="xl"
      w="full"
      style={style.container}
    >
      <Box pr="md">
        <EntityListAvatar name={name} index={index} />
      </Box>
      <EntityListTitle name={name} index={index} />
      {title ? (
        <Box>
          <Box direction="horizontal">
            <EntityListMenu
              name={name}
              index={index}
              isMenuOpen={isMenuOpen}
              setMenuIndex={setMenuIndex}
            />
            <Header.Button
              tabIndex={-1}
              onPress={() => {
                setValue(
                  `${name}.${index}`,
                  getEmptyEntity(
                    getValues(`${name}.${index}.color`) || getRandomColor(),
                  ),
                  {
                    shouldValidate: true,
                    shouldDirty: true,
                  },
                );
              }}
            >
              <Icon name="close-outline" />
            </Header.Button>
          </Box>
        </Box>
      ) : null}
    </Box>
  );
});
const style = StyleSheet.create((theme) => ({
  container: {
    minHeight: theme.size(12),
  },
}));
